// ============================================================
// Pont API de l'espace Discord (dashboard repris de paladium-support-app).
//
// Adapté au panel RecubeBE : on GARDE notre authentification (JWT Recube), on ne
// reprend PAS l'OAuth/session Discord du dashboard d'origine.
//  - Token partagé avec le reste du panel (clé localStorage `recubebe_xbox_token`).
//  - En-tête `X-Project` = jeu actif.
//  - Base = passerelle côté backend `/api/discord-bot` (à câbler ultérieurement) :
//    notre backend relaiera vers l'API du bot. Tant que la passerelle n'existe pas,
//    les appels échouent proprement (états vides), le front reste fonctionnel.
//    Surchargable via VITE_DISCORD_API_BASE.
// ============================================================

import { useGameStore } from '@/stores/game.store';

export const API_BASE_URL = (import.meta.env.VITE_DISCORD_API_BASE as string | undefined) ?? '/api/discord-bot';

const TOKEN_KEY = 'recubebe_xbox_token';

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

export class NetworkError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NetworkError';
  }
}

export async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem(TOKEN_KEY);
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'X-Project': useGameStore.getState().activeGameId,
    ...((options.headers as Record<string, string> | undefined) ?? {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  try {
    const res = await fetch(`${API_BASE_URL}${path}`, {
      cache: 'no-store',
      ...options,
      headers,
    });

    if (res.status === 401) {
      window.dispatchEvent(new CustomEvent('recube:unauthenticated'));
      throw new ApiError(401, 'Session expirée');
    }
    if (!res.ok) {
      throw new ApiError(res.status, `API error ${res.status}`);
    }

    const ct = res.headers.get('content-type') ?? '';
    if (res.status === 204 || !ct.includes('application/json')) return undefined as T;
    return (await res.json()) as Promise<T>;
  } catch (error) {
    if (error instanceof ApiError) throw error;
    if (error instanceof TypeError && error.message.includes('fetch')) {
      throw new NetworkError('Backend du bot Discord injoignable.');
    }
    throw error;
  }
}
